const handleFetchLocationsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.locations = action.payload.data;
  state.message = action.payload.message;
};

export {
  handleFetchLocationsFulfilled
};
